<div id="list-item-1" #smartTagItem class="smart-tag-item d-flex">
    <div class="smart-tag-image-container flex-shrink-0">
        <div>
            <img class="img-thumbnail img-responsive smart-tag-image"
                 [src]="previewPhoto"
                 (click)="openPreview()"
                 (load)="onImageLoad()"
                 (error)="onImageError()"
				 *ngIf="photoIsAvailable">

            <span *ngIf="showLoading"
                class="loading">
                <div class="img-thumbnail loader-icon">
                    <i class="fas fa-images"></i>
                </div>
            </span>

			<div class="smart-tag-empty-rules-message" *ngIf="!photoIsAvailable">
					<img src="assets/img/placeholder/No-file-asset.png">
					<label class="no-results">No Image Available</label>
			</div>
        </div>

		<div class="custom-action-container rotate" *ngIf="photoIsAvailable && isEditing" (click)="rotateImage()">
			<i class="fas fa-sync"></i>
		</div>

		<div class="custom-action-container blurs" *ngIf="photoIsAvailable && isEditing && !item?.data?.imageless" (click)="openDrawForms()">
			<i class="fas fa-pen-paintbrush"></i>
		</div>

        <div class="select-action-container" *ngIf="photoIsAvailable" (click)="selectSmartTag(true)">
            <i [ngClass]="selected ? 'fas fa-check-square' : 'fa-square far'"></i>
        </div>
    </div>
    <div class="smart-tag-info flex-grow-1 ms-3">
        <h4 class="smart-tag-name">
            <div class="smart-tag-title" [innerHtml]="version === 'v2' ? item.data.renderView.title : item.data.title"></div>
            <div class="smart-tag-action"
                *ngIf="isEditing">
                <a class="btn action-delete" (click)="deleteSmartTag()"><i class="fa-trash-alt fas"></i></a>
                <a class="btn action-edit" *ngIf="photoIsAvailable" (click)="editSmartTag()"><i class="fa fa-pencil"></i></a>
            </div>
        </h4>

        <div class="smart-tag-description"
             [ngClass]="{'full-description' : displayShowMoreButton ? showFullDescription : true}"
             [innerHtml]="version === 'v2' ? item.data.renderView.description : ''">
        </div>

		<div class="smart-tag-ai" *ngIf="isAIgenerated">
			<p><i class="fa-solid fa-robot"></i> AI generated</p>
			<div class="gauge">
				<div class="progressgauge" style="--value: {{confidence}}"
					[ngClass]="{
						'success': confidence > 75,
						'warning': confidence > 55 && confidence <= 75,
						'danger': confidence <= 55
					}">
				</div>
			</div>
		</div>

        <!--<div #collapse="ngbCollapse" [attr.aria-expanded]="showFullDescription" [(ngbCollapse)]="!showFullDescription">
            <div [innerHtml]="version === 'v2' ? item.data.renderView.description : ''"></div>
        </div>-->

        <p *ngIf="displayShowMoreButton">
            <a class="smart-tag-link link-primary"
            (click)="showFullDescription = !showFullDescription">
            View {{showFullDescription ? 'less' : 'more'}}</a>
        </p>
    </div>
</div>

<!--<ngx-gallery [options]="optionsPreview" [images]="album" #onlyPreviewGallery></ngx-gallery>-->
